import { useEffect } from 'react';
import { useUserStore } from 'store';

import { sourceArgs } from './dataSources';
import { useWidgetFrame } from './frameContext';
import { useWidgetData } from './useWidgetData';

/** `useWidgetData` from a data source object. */
export function useSource(source, options = {}) {
  const [key, fetch, base] = sourceArgs(source);
  return useWidgetData(key, fetch, { ...base, ...options });
}

/** Push header content (chip, link, count, empty, hidden) to the frame whenever deps change. */
export function useHeader(values, deps) {
  const frame = useWidgetFrame();
  const setHeader = frame?.setHeader;
  useEffect(() => {
    setHeader?.(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export function useOrg() {
  return useUserStore((state) => state.currentOrganization);
}

export const listOf = (payload) => (Array.isArray(payload) ? payload : payload?.results || payload?.items || []);
